import React, { useState } from 'react';

const NOTIFICATIONS = [
  { id: 1, type: 'alert', title: 'Server CPU at 92%', body: 'Production server-01 is under heavy load. Consider scaling.', time: '2 min ago', read: false },
  { id: 2, type: 'info', title: 'Deployment successful', body: 'v2.4.1 deployed to staging environment without errors.', time: '15 min ago', read: false },
  { id: 3, type: 'warning', title: 'SSL cert expiring', body: 'SSL certificate for api.example.com expires in 7 days.', time: '1 hr ago', read: true },
  { id: 4, type: 'alert', title: 'Failed login attempts', body: '5 failed login attempts from IP 192.168.1.45 in the last 10 minutes.', time: '2 hr ago', read: false },
  { id: 5, type: 'info', title: 'Backup completed', body: 'Daily database backup completed successfully. Size: 2.3 GB.', time: '3 hr ago', read: true },
];

const FAQ_ITEMS = [
  { q: 'How do I reset my password?', a: 'Go to Settings → Security → Change Password. You will receive an OTP on your registered email. Enter the OTP and set a new password of at least 8 characters.' },
  { q: 'What payment methods are accepted?', a: 'We accept all major credit/debit cards (Visa, MasterCard, Amex), UPI, net banking, and wallet payments via Paytm and PhonePe.' },
  { q: 'How do I cancel an order?', a: 'Orders can be cancelled within 24 hours of placement. Navigate to My Orders → Select Order → Cancel. A full refund will be initiated within 3–5 business days.' },
  { q: 'How do I contact support?', a: 'Support is available 24/7. Use the live chat button at the bottom-right, email us at support@example.com, or call 1800-XXX-XXXX (toll-free).' },
  { q: 'What is the return policy?', a: 'Products can be returned within 30 days of delivery if unused and in original packaging. Electronics have a 7-day return window. Perishables are non-returnable.' },
];

const PROFILE_TABS = ['Overview', 'Activity', 'Security', 'Integrations'];

export default function TabsAndAccordion() {
  const [activeTab, setActiveTab] = useState(0);
  const [profileTab, setProfileTab] = useState('Overview');
  const [openFaq, setOpenFaq] = useState(null);
  const [notifications, setNotifications] = useState(NOTIFICATIONS);
  const [notifFilter, setNotifFilter] = useState('all');

  const markRead = (id) => setNotifications(n => n.map(x => x.id === id ? { ...x, read: true } : x));
  const markAllRead = () => setNotifications(n => n.map(x => ({ ...x, read: true })));
  const dismiss = (id) => setNotifications(n => n.filter(x => x.id !== id));
  const unread = notifications.filter(n => !n.read).length;

  const filteredNotifs = notifications.filter(n => {
    if (notifFilter === 'unread') return !n.read;
    if (notifFilter === 'alert') return n.type === 'alert';
    return true;
  });

  const typeIcon = (t) => ({ alert: '🔴', warning: '🟡', info: '🔵' }[t] || '⚪');

  return (
    <div className="eval-section">
      <h2 className="eval-section-title">🗂 Tabs, Accordions & Notifications <span className="eval-badge-scenario">Navigation Patterns / State</span></h2>
      <p className="eval-desc">Test: nested tabs, accordion open/close, notification read/dismiss, filter states.</p>

      {/* Outer tabs */}
      <div className="ta-tabs-bar">
        {['Notifications', 'FAQ / Accordion', 'Profile Tabs'].map((t, i) => (
          <button key={t} className={`ta-tab ${activeTab === i ? 'ta-tab-active' : ''}`} onClick={() => setActiveTab(i)}>
            {t} {t === 'Notifications' && unread > 0 && <span className="ta-badge">{unread}</span>}
          </button>
        ))}
      </div>

      <div className="ta-panel">

        {/* Notifications Panel */}
        {activeTab === 0 && (
          <div>
            <div className="ta-notif-toolbar">
              <div className="ta-filter-btns">
                {['all', 'unread', 'alert'].map(f => (
                  <button key={f} className={`eval-btn eval-btn-sm ${notifFilter === f ? 'eval-btn-primary' : ''}`} onClick={() => setNotifFilter(f)}>
                    {f.charAt(0).toUpperCase() + f.slice(1)}
                  </button>
                ))}
              </div>
              {unread > 0 && <button className="eval-btn eval-btn-sm" onClick={markAllRead}>Mark all read</button>}
            </div>
            {filteredNotifs.length === 0 && <div className="ta-empty">No notifications to show.</div>}
            {filteredNotifs.map(n => (
              <div key={n.id} className={`ta-notif ${n.read ? 'ta-notif-read' : ''}`}>
                <span className="ta-notif-icon">{typeIcon(n.type)}</span>
                <div className="ta-notif-body">
                  <div className="ta-notif-title">{n.title}</div>
                  <div className="ta-notif-text">{n.body}</div>
                  <div className="ta-notif-time">{n.time}</div>
                </div>
                <div className="ta-notif-actions">
                  {!n.read && <button className="eval-btn eval-btn-sm" onClick={() => markRead(n.id)}>Mark read</button>}
                  <button className="eval-btn eval-btn-sm eval-btn-danger" onClick={() => dismiss(n.id)}>✕</button>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* FAQ Accordion */}
        {activeTab === 1 && (
          <div className="ta-accordion">
            {FAQ_ITEMS.map((item, i) => (
              <div key={i} className={`ta-accordion-item ${openFaq === i ? 'ta-accordion-open' : ''}`}>
                <button className="ta-accordion-header" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                  <span>{item.q}</span>
                  <span className="ta-accordion-icon">{openFaq === i ? '▲' : '▼'}</span>
                </button>
                {openFaq === i && <div className="ta-accordion-body">{item.a}</div>}
              </div>
            ))}
          </div>
        )}

        {/* Nested Profile Tabs */}
        {activeTab === 2 && (
          <div>
            <div className="ta-inner-tabs">
              {PROFILE_TABS.map(t => (
                <button key={t} className={`ta-inner-tab ${profileTab === t ? 'ta-inner-tab-active' : ''}`} onClick={() => setProfileTab(t)}>{t}</button>
              ))}
            </div>
            <div className="ta-inner-panel">
              {profileTab === 'Overview' && (
                <div className="ta-profile-overview">
                  <div className="ta-avatar">JD</div>
                  <div className="ta-profile-info">
                    <h3>Jane Doe</h3>
                    <p>Senior Product Manager · Engineering Division</p>
                    <p style={{color:'#888',fontSize:13}}>Joined January 2020 · Last active today</p>
                    <div className="ta-profile-chips">
                      <span>Product Strategy</span><span>Roadmapping</span><span>Agile</span><span>Stakeholder Mgmt</span>
                    </div>
                  </div>
                </div>
              )}
              {profileTab === 'Activity' && (
                <div className="ta-activity">
                  {['Updated roadmap Q2 2026', 'Closed 12 tickets in Sprint 14', 'Approved budget for Team B', 'Presented to stakeholders', 'Onboarded 2 new engineers'].map((a, i) => (
                    <div key={i} className="ta-activity-item">
                      <span className="ta-act-dot" />
                      <span>{a}</span>
                      <span className="ta-act-time">{i + 1}d ago</span>
                    </div>
                  ))}
                </div>
              )}
              {profileTab === 'Security' && (
                <div className="ta-security">
                  <div className="ta-sec-row"><span>Two-Factor Auth</span><span className="sh-badge sh-badge-yes">Enabled</span></div>
                  <div className="ta-sec-row"><span>Last Password Change</span><span>42 days ago</span></div>
                  <div className="ta-sec-row"><span>Active Sessions</span><span>3 devices</span></div>
                  <div className="ta-sec-row"><span>Login Alerts</span><span className="sh-badge sh-badge-yes">On</span></div>
                  <button className="eval-btn eval-btn-danger" style={{marginTop:12}}>Revoke All Sessions</button>
                </div>
              )}
              {profileTab === 'Integrations' && (
                <div className="ta-integrations">
                  {[
                    { name: 'Slack', status: true, icon: '💬' },
                    { name: 'GitHub', status: true, icon: '🐙' },
                    { name: 'Jira', status: false, icon: '📌' },
                    { name: 'Google Calendar', status: true, icon: '📅' },
                  ].map(int => (
                    <div key={int.name} className="ta-int-row">
                      <span>{int.icon} {int.name}</span>
                      <span className={`sh-badge ${int.status ? 'sh-badge-yes' : 'sh-badge-no'}`}>{int.status ? 'Connected' : 'Not Connected'}</span>
                      <button className="eval-btn eval-btn-sm">{int.status ? 'Disconnect' : 'Connect'}</button>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
